import { StringParam, useQueryParam } from "use-query-params";
import close from "../../../assets/images/close.svg"

// Mapeo genérico de títulos a query params
const FILTER_QUERY_PARAMS = {
    "Status": "clients-status",
    "Industry": "clients-industry",
    "Location": "clients-location",
}

export function ClientFilter({
    icon,
    title = "Filter title",
    filterOptions,
    openFilter,
    onFilterClick,
    onFilterApply,
    onFilterClear,
}) {
    // Obtener dinámicamente el query param basado en el título
    const queryParamKey = FILTER_QUERY_PARAMS[title]
    const [activeFilter] = useQueryParam(queryParamKey, StringParam)
    
    const handleFilterClick = (e) => {
        onFilterClick?.(e, title)
    }

    const handleFilterSave = () => {
        onFilterApply?.(title)
    }

    const handleFilterClear = () => {
        onFilterClear?.(title)
    }

    const filterShowClass = openFilter === title ? "show" : ""
    const activeFilterClass = activeFilter ? "active" : ""
    
    return (
        <div className={`filter ${filterShowClass} ${activeFilterClass}`} onClick={handleFilterClick}>
            {icon && <img src={icon} alt="Prodensa Supplier" />}

            <span>{title}</span>

            <div className={`filterOptions ${filterShowClass} `} onClick={(e) => !e.target.matches("button") && e.stopPropagation()}>
                <img src={close} alt="Prodensa Automation" onClick={() => {}} className="closeImg d-lg-none" />

                <span className="title">
                    {icon && <img className="d-lg-none imgMenu" src={icon} alt="Prodensa Supplier" />}

                    {title}
                </span>

                <div className="optionsScroll">
                    {filterOptions}
                </div>

                <div className="actions">
                    <button onClick={handleFilterClear}>Clear</button>
                    <button onClick={handleFilterSave}>Apply</button>
                </div>
            </div>
        </div> 
    )
}